var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NewsPopup'),(!_vm.hideAppBar)?_c('v-app-bar',{attrs:{"app":"","color":"#139393","dark":""}},[_c('SiteLogo'),_c('v-spacer')],1):_vm._e(),_c('v-main',[_c('router-view',{key:_vm.$route.fullPath})],1),(!_vm.hideAppBar)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }